import { Component, EventEmitter, Output } from '@angular/core';

import { Navbar } from '../navbar/navbar';

@Component({
  selector: 'app-hero-section',
  imports: [Navbar],
  templateUrl: './hero-section.html',
  styleUrl: './hero-section.css',
})
export class HeroSection {
  @Output() scrollToMainContent = new EventEmitter<void>();

  onScrollToMainContent() {
    this.scrollToMainContent.emit();
  }
}
